import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getProductSummary } from '@/service/dashboard';

const defaultState = {
  fetching: false,
  error: null,
  query: {},
  data: {}
}

export const fetchProductSummary = createAsyncThunk(
  'productSummary/fetchProductSummary',
  async ({query = {}}, {rejectWithValue}) => {
    try {
        const response = await getProductSummary(query);
        return {
            data: response.data,
            query
        }
    } catch (error) {
        return rejectWithValue(error.response?.data || '获取产康汇总数据失败');
    }
  }
)

const productSummarySlice = createSlice({
  name: 'productSummary',
  initialState: defaultState,
  reducers: {
    resetProductSummaryState: (state, action) => {
      state.query = {};
      state.data = {};
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProductSummary.pending, (state, action) => {
        state.fetching = true;
        state.error = null;
        state.query = action.meta.arg.query;
      })
      .addCase(fetchProductSummary.fulfilled, (state, action) => {
        state.fetching = false;
        state.error = null;
        state.data = action.payload.data;
        state.query = action.payload.query;
      })
      .addCase(fetchProductSummary.rejected, (state, action) => {
        state.fetching = false;
        state.error = action.payload;
        state.data = {};
      });
  }
})

export const { resetProductSummaryState } = productSummarySlice.actions;
export default productSummarySlice.reducer;
